import * as React from 'react';

let joinedClassName: string | undefined;

export default {
  getJoinedClassName: () => {
    // storing in session storage because on actual mobile devices there is something weird going on between the routes.
    const sessionClassName =
      window && window.sessionStorage && window.sessionStorage.getItem('join:className');
    return sessionClassName || joinedClassName;
  },
  setJoinedClassName: (className: string) => {
    window && window.sessionStorage && window.sessionStorage.setItem('join:className', className);
    joinedClassName = className;
  },
};
